const ArrowBox = ({ items, isRotated, orientation, isGeneratingPdf, setIsGeneratingPdf }) => {
  const rotation = orientation === 'right-to-left' ? 180 : 0;
  const displayItems = items;
  const boxHeight = isGeneratingPdf ? '22px' : '29px';

  return (
    <div style={{ position: 'relative' }}>
      <div style={{ display: 'flex', transform: `rotate(${rotation}deg)`, transition: 'transform 0.3s ease-in-out' }}>
        <div style={{ display: 'flex', alignItems: 'center', backgroundColor: '#FFDE21', color: 'black', padding: '4px 12px', position: 'relative', width: '300px', height: boxHeight }}></div>
        <div style={{ width: 0, height: 0, borderTop: '15px solid transparent', borderBottom: '15px solid transparent', borderLeft: '15px solid #FFDE21' }} />
      </div>
      <div style={{ display: 'flex', gap: '8px', alignItems: 'center', flexWrap: 'wrap' }}>
        {displayItems.map((item, i) => (
          <p key={i} style={{ fontWeight: 'bold', margin: 0, whiteSpace: 'nowrap', fontSize: '0.75rem', display: 'inline', paddingLeft: '2.25rem' }}>{item}</p>
        ))}
      </div>
    </div>
  );
};

export default ArrowBox;